import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import clsx from "clsx";

import SignatureElement from "./SignatureElement";
import HeaderElement from "./HeaderElement";

import { getDisplayName } from "../../../utils";

function renderElements(
  elements,
  isPremium,
  { elementSelected, jurisdiction, participants, isDynamic }
) {
  let charactersLength = 0;
  let hasThreePoint = false;
  if (!elements || !elements.length) {
    return null;
  }
  let statementsIndex = 0;

  let clausesIndex = 0;

  return elements.map((element, i) => {
    charactersLength += element.content?.length ?? 0;

    if (charactersLength > 9000 && isPremium) {
      if (!hasThreePoint) {
        hasThreePoint = true;
        return <div className="text-center">....</div>;
      }
      return null;
    }

    if (!element?.content?.length) {
      return null;
    }
    if (element.type === "clause") {
      clausesIndex++;
    } else if (element.type === "statement") {
      statementsIndex++;
    }

    return (
      <ContractElement
        key={element._id}
        index={i}
        clausesIndex={clausesIndex}
        statementsIndex={statementsIndex}
        isContractDynamic={isDynamic}
        isSelected={elementSelected === element._id}
        participants={participants}
        jurisdiction={jurisdiction}
        {...element}
      />
    );
  });
}

function ElementsContainer({ contract, participants, elementSelected }) {
  return (
    <div className="p-4 elements-container" style={{ minWidth: 500 }}>
      {renderElements(
        contract.elements,
        ["premium", "free"].includes(contract?.previewType),
        {
          elementSelected,
          participants: contract.participants,
          jurisdiction: contract.jurisdiction,
          isDynamic: contract.isDynamic,
        }
      )}
    </div>
  );
}

export function OldContractPreviewTrato({
  contract,
  card,
  header,
  elementSelected,
  participants,
}) {
  const { t } = useTranslation("common");

  console.log({ p: participants, pc: contract.participants });

  if (card) {
    return (
      <Container
        fluid
        className={clsx("d-flex justify-content-center")}
        style={{ width: 700, maxHeight: 800 }}
      >
        <Card className={clsx("my-3 shadow-sm")}>
          {header && (
            <CardHeader>
              <h4 className="font-weight-bold mb-0">{contract.name}</h4>
              <p className="text-muted mb-0">{t("preview")}</p>
            </CardHeader>
          )}
          <CardBody
            className={clsx("contract-preview overflow-auto ")}
            style={{ minHeight: 500 }}
          >
            <ElementsContainer
              contract={contract}
              participants={participants}
              elementSelected={elementSelected}
            />
          </CardBody>
        </Card>
      </Container>
    );
  }

  return (
    <ElementsContainer
      contract={contract}
      participants={participants}
      elementSelected={elementSelected}
    />
  );
}

function ContractElement({
  type,
  content = "",
  number,
  index,
  clausesIndex,
  statementsIndex,
  staticfield,
  isSelected,
  isContractDynamic,
  participants,
  jurisdiction,
}) {
  if (type === "break") {
    return <div className="page-break"></div>;
  }

  const getOrdinalNumber = (number) => {
    if (!isNaN(number)) {
      const num = String(number);
      const units = [
        "primera",
        "segunda",
        "tercera",
        "cuarta",
        "quinta",
        "sexta",
        "séptima",
        "octava",
        "novena",
      ];
      const dozens = [
        "décima",
        "vigésima",
        "trigésima",
        "cuadragésima",
        "quincuagésima",
        "sexagésima",
        "septuagésima",
        "octogésima",
        "nonagésima",
      ];
      const hundreds = [
        "centésima",
        "ducentésima",
        "tricentésima",
        "cuadringentésima",
        "quingentésima",
        "sexcentésima",
        "septingentésima",
        "octingentésima",
        "noningentésima",
      ];
      const array = [units, dozens, hundreds];
      const word = [];
      let index = 0;
      for (let i = num.length; i > 0; i--) {
        const ordinalText = array[index][Number(num[i - 1]) - 1];
        if (ordinalText) {
          word.unshift(ordinalText);
        }

        index++;
      }

      return word?.join(" ")?.toUpperCase();
    }

    return "";
  };

  const renderLogo = () => {
    return <div dangerouslySetInnerHTML={{ __html: content }} />;
  };

  const renderHeader = (isStatic) => {
    return (
      <div className="header-text contenteditable">
        <HeaderElement
          participants={participants}
          type={type}
          isStatic={isStatic}
        >
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </HeaderElement>
      </div>
    );
  };
  const renderTitle = () => {
    return (
      <div className="simple-title contenteditable">
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  };

  const renderText = () => {
    return (
      <div className="simple-text contenteditable">
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  };

  const renderTable = () => {
    return (
      <div className="simple-text contenteditable">
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  };

  const renderStatement = () => {
    return (
      <div className="statement-text contenteditable">
        <div className="statement-title">
          {" "}
          {isContractDynamic ? statementsIndex : number ? number : index}.
        </div>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  };

  const renderClause = () => {
    return (
      <div className="clause-text contenteditable">
        <div className="clause-title">
          {isContractDynamic
            ? getOrdinalNumber(clausesIndex)
            : number
            ? getOrdinalNumber(number)
            : getOrdinalNumber(index)}
          .
        </div>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  };

  const renderDocumentFooter = () => {
    return (
      <div id="pageFooter">
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  };

  const renderDocumentHeader = () => {
    return (
      <div id="pageHeader">
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  };

  const renderSignature = () => {
    console.log({ participants });
    return (
      <>
        <div className="signature-content">
          {participants &&
            participants?.map((participant) => (
              <React.Fragment key={participant._id}>
                {(content.includes(participant._id) ||
                  participant.isNewParticipant) && (
                  <SignatureElement
                    participantId={participant._id}
                    label={participant.label}
                    name={
                      participant.obligation === "legal"
                        ? getDisplayName(participant.name)
                        : getDisplayName(
                            participant.name,
                            participant.last_name
                          )
                    }
                    representative={participant.representative}
                    obligation={participant.obligation}
                    jurisdiction={jurisdiction ?? "mx"}
                  />
                )}
              </React.Fragment>
            ))}
        </div>
      </>
    );
  };

  return (
    <div className={clsx("element px-1", isSelected && "border border-accent")}>
      <div className="element-content">
        {/* {type === 'staticheader' && renderHeader(staticfield)}  */}
        {type === "header" && renderHeader(staticfield)}
        {type === "document_logo" && renderLogo()}
        {type === "title" && renderTitle()}
        {type === "text" && renderText()}
        {type === "table" && renderTable()}
        {type === "statement" && renderStatement()}
        {type === "clause" && renderClause()}
        {type === "signature" && renderSignature()}
        {type === "document_footer" && renderDocumentFooter()}
        {type === "document_header" && renderDocumentHeader()}
      </div>
    </div>
  );
}
